import React from "react";

import "../../../../styles/css/App.css";

import { Switch, Route, useRouteMatch, withRouter } from "react-router-dom";
import TablePlaces from "../table-places";
import PlaceForm from "../form/place-form";
import { PlaceCategories } from '../../../../plas/map/places/models';
import alerter from "../../../alerts/alerter.jsx";


function OpenAir({ history }) {
  
  let { path, url } = useRouteMatch();

  const onOpen = (event, rowData) => {
    if (rowData !== undefined) {
      history.push(`${url}/` + rowData.id);
    }
  }

  const onClose = () => {
    history.goBack()
  }

  const onSave = () => {
    onClose()
    alerter.showSuccess("Se guardaron los cambios del lugar.")
  }

  const options = {
    contact: {
      delivery: 'hidden'
    }
  }

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <TablePlaces
            open={onOpen}
            rootCategory={PlaceCategories.OPEN_AIR}
            title={"Lugares al aire libre"}
            deleteMessage="¿Está seguro de que desea borrar este lugar?"
            noDataMessage="No hay lugares para mostrar"
            options={options} />
        </Route>
        <Route exact path={`${path}/:placeId`}
          render={ (props) => 
            <PlaceForm 
              rootCategory={PlaceCategories.OPEN_AIR} 
              placeId={props.match.params.placeId}
              onSave={onSave}
              options={options}
              onCancel={onClose}/>
          }
        />
      </Switch>
    </div>
  );

}

export default withRouter(OpenAir);
